import { Usecase, UsecaseListItem } from "../../model";
import { OpenAPIV3 } from "../../@types";
import { Ajax, CrudApiBase } from "../infra";
import { StorageLogic } from "../../logic";

/**
 * Provides CRUD access for Service Models
 */
export class Usecases extends CrudApiBase<Usecase, UsecaseListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/usecases";

  constructor(ajax: Ajax) {
    super(ajax);
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): Usecase {
    return {
      actions: [],
      schema: this.getTempSchema(),
    };
  }

  /**
   * Saves an item to the storage.
   * If id is null, this is add/insert. If id exists, this is update.
   * @param itemToSave - The item that is updated/inserted.
   * @returns A Promise with result data as saved to the storage (contains id, createAt, owner etc.).
   */
  public save(itemToSave: Usecase): Promise<Usecase> {
    return super.save(itemToSave);
  }

  /**
   * Gets an URL to a resource (currently HTML user interface) in the usecase.
   * @param uri Full uri of the usecase.
   * @param type Type of the resource to fetch. Only "html" is currently supported.
   * @param ix Index number of the view if there are several. Default is 0.
   */
  public getResourceUrl(uri: string, type: "js" | "html", ix = 0): string {
    const id = StorageLogic.getIdAtOwner(uri);
    if (type == "js") {
      throw new Error("Resource URL for JavaScript is not yet supported.");
    }
    return `${this.ajax.getServerAddress()}${this.getBaseUrl()}/${id}/views/${ix.toFixed()}`;
  }

  private getTempSchema(): OpenAPIV3.Document {
    return {
      openapi: "3.0.1",
      info: {
        title: "Usecase schema",
        version: "1.0"
      },
      paths: {},
      components: {
        schemas: {
        },
      },
    };
  }
}
